import { useState } from "react";
import { Menu, X } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const LINKS = [
  { label: "Le déroulé de l'atelier", href: "#atelier", testid: "nav-link-atelier" },
  { label: "Nos Ateliers", href: "#ateliers", testid: "nav-link-ateliers" },
  { label: "Coups de cœur", href: "#coups-de-coeur", testid: "nav-link-coups" },
  { label: "Le Café", href: "#cafe", testid: "nav-link-cafe" },
  { label: "Cartes Cadeaux", href: "#cadeaux", testid: "nav-link-cadeaux" },
  { label: "Infos & Accès", href: "#contact", testid: "nav-link-contact" },
];

export const scrollTo = (hash) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -90, duration: 1.4 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Nav({ content }) {
  const [open, setOpen] = useState(false);
  const brand = content?.brand_name || "Terre à Deux";

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollTo(href);
  };

  return (
    <header data-testid="main-nav" className="fixed top-4 inset-x-0 z-50 px-4">
      <div className="mx-auto max-w-6xl rounded-full border border-[#E5DCD3] bg-[#FBF8F3]/85 backdrop-blur-md px-5 py-3 flex items-center justify-between shadow-[0_8px_30px_rgba(32,24,21,0.06)]">
        <a href="#" data-testid="nav-brand" onClick={(e) => go(e, "#hero")} className="flex items-center gap-2.5">
          {content?.logo_url ? (
            <img src={mediaUrl(content.logo_url)} alt={brand} data-testid="nav-logo" className="h-12 w-12 rounded-xl object-cover border border-[#E5DCD3] shadow-sm" />
          ) : (
            <span className="h-8 w-8 rounded-full bg-[#C85A32] text-[#FBF8F3] flex items-center justify-center font-display text-lg italic">T</span>
          )}
          <span className="font-display text-lg font-semibold tracking-tight text-[#201815]">{brand}</span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              onClick={(e) => go(e, l.href)}
              className="text-sm text-[#5C4E48] hover:text-[#C85A32] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            data-testid="nav-reserve-cta"
            onClick={(e) => go(e, "#reservation")}
            className="hidden sm:inline-flex items-center rounded-full bg-[#C85A32] hover:bg-[#A84623] text-[#FBF8F3] text-sm font-medium px-5 py-2.5 transition-colors duration-300"
          >
            Réserver
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden h-9 w-9 rounded-full border border-[#E5DCD3] flex items-center justify-center text-[#201815]"
            aria-label="Menu"
          >
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden mx-auto max-w-6xl mt-2 rounded-3xl border border-[#E5DCD3] bg-[#FBF8F3]/95 backdrop-blur-md p-4 flex flex-col gap-1">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.testid}-mobile`}
              onClick={(e) => go(e, l.href)}
              className="px-4 py-3 rounded-2xl text-[#201815] hover:bg-[#F4EFEA] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="nav-reserve-cta-mobile"
            onClick={(e) => go(e, "#reservation")}
            className="mt-2 rounded-full bg-[#C85A32] text-[#FBF8F3] text-sm font-medium px-5 py-3"
          >
            Réserver un créneau
          </button>
        </div>
      )}
    </header>
  );
}
